import Link from '../../views/Management';
import { connect } from 'react-redux';
import { actions } from '../../../state/assessment';
import {push} from "connected-react-router";
import {actions as Authaction} from "../../../state/auth";

const mapStateToProps = (state, ownProps) => ({
  intel: ownProps.match.params.intel,
  locale: ownProps.match.params.locale,
  status: state.shift.status,
  membername: state.shift.assessment.membername,
  memberusername: state.shift.assessment.memberusername,
  memberemail: state.shift.assessment.memberemail,
  membertelephone: state.shift.assessment.membertelephone,
  memberrole: state.shift.assessment.memberrole,
  memberstatus: state.shift.assessment.memberstatus,
  nextaction: state.shift.assessment.nextaction,
  popwindow: state.shift.status.popwindow,
  username: state.shift.auth.username,
  usersList: state.shift.assessment.usersList,
  role: state.shift.auth.role,
  customerid: state.shift.auth.customerid,
});
const mapDispatchToProps = (dispatch, ownProps) => {
  const { locale } = ownProps.match.params;
  return {
    logout: () => {
      localStorage.clear();
      sessionStorage.clear();
      dispatch(Authaction.logout());
    },

    changeAdmin: (oldAdmin,newAdmin,fun) => {
      // console.log(oldAdmin)
      // console.log(newAdmin)
      dispatch(actions.changeAdmin(oldAdmin,newAdmin)).then(
        ()=>{fun()}
      )
    },

    getusersList: username => {
      dispatch(actions.usersList(username));
    },

    inviteUser: (firstName, lastName, email, phoneNumber,adminUsername,role,customerid,fun) =>{
      dispatch(actions.register(firstName, lastName, email, phoneNumber,adminUsername,role,customerid)).then(()=>fun());
    },

    deleteUser: (username, email, adminUsername,props,selectItem) =>{
      dispatch(actions.unregister(username, email, adminUsername)).then(
        setTimeout(() => {
          // selectItem({});
          // props.getusersList(username)
          window.location.reload()();
        }, 1000)
      )
    },
    clickBackHandler: value => {
      dispatch(push(`/${locale}/shift`));
    },
    reactiveUser: (username, email, adminUsername,props,selectItem) =>{
      dispatch(actions.reactiveUser(username, email, adminUsername)).then(
        setTimeout(() => {
          // selectItem({});
          // win.getusersList(username)
          window.location.reload()();
        }, 1000)
      )
    },
  }
};

const Management = connect(
  mapStateToProps,
  mapDispatchToProps
)(Link);

export default Management;



// WEBPACK FOOTER //
// ./src/components/container/Management/index.js